import { useEffect, useState } from 'react';

export default function useIsTabbing() {
  const [isTabbing, setIsTabbing] = useState(false);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (['Tab', 'ArrowDown', 'ArrowUp'].includes(e.key)) {
        if (!isTabbing) {
          document.body.classList.add('user-is-tabbing');
          setIsTabbing(true);
        }
      }
    };

    const handlePointerMove = () => {
      if (isTabbing) {
        document.body.classList.remove('user-is-tabbing');
        setIsTabbing(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('pointermove', handlePointerMove);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('pointermove', handlePointerMove);
    };
  }, [isTabbing]);

  return isTabbing;
}
